import http from 'MeetingsBase/http/apiClient';
import { BRANDING_ENDPOINT } from 'MeetingsAdmin/constants/endpoints';
export function fetchGlobalBranding(portalId) {
  return http.get(`${BRANDING_ENDPOINT}/branding/${portalId}`);
}